export const IS_KEYBOARD_STORAGE_KEY = 'isKeyboard';

export const KEYBOARD_NAVIGATION_KEYS = [
  'Tab',
  'Enter',
  ' ',
  'Escape',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
];

export const FOCUSABLE_SELECTOR =
  'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
